var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.437,
    height: 50.384,
    viewBox: "0 0 36.437 50.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "labReport",
    transform: "translate(-56.145 -390.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9166",
    "data-name": "Group 9166",
    transform: "translate(56.645 391.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4212",
    "data-name": "Path 4212",
    d: "M1044.3,450.944V440.237h-10.663Z",
    transform: "translate(-1008.756 -440.063)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4213",
    "data-name": "Path 4213",
    d: "M1008.851,478.653v10.707h10.707Z",
    transform: "translate(-1008.756 -440.063)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4214",
    "data-name": "Path 4214",
    d: "M1021.142,440.792v5.481a.952.952,0,0,0,.942.943h.385a.966.966,0,0,0,.944-.815v-.128a3.281,3.281,0,0,1,6.509,0v.128a.931.931,0,0,0,.942.815.952.952,0,0,0,.943-.943v-5.481a.752.752,0,0,0-.73-.729h-9.165A.734.734,0,0,0,1021.142,440.792Z",
    transform: "translate(-1008.756 -440.063)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4215",
    "data-name": "Path 4215",
    d: "M1044.193,489.447h-35.437V440.727h9.8",
    transform: "translate(-1008.756 -440.063)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4216",
    "data-name": "Path 4216",
    d: "M1036.175,440.727h8.018v48.719",
    transform: "translate(-1008.756 -440.063)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9167",
    "data-name": "Group 9167",
    transform: "translate(60.645 411.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4217",
    "data-name": "Path 4217",
    d: "M1021.118,463.222a7.66,7.66,0,0,1,9.666-.952,7.657,7.657,0,0,1,2.112,2.112,7.66,7.66,0,0,1,0,8.506,7.657,7.657,0,0,1-2.112,2.112,7.655,7.655,0,0,1-9.666-11.778Z",
    transform: "translate(-1013.334 -460.978)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4218",
    "data-name": "Path 4218",
    d: "M1029.728,465.155a4.71,4.71,0,0,0-7.905,3.462,4.684,4.684,0,0,0,.442,2",
    transform: "translate(-1013.334 -460.978)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4219",
    "data-name": "Path 4219",
    d: "M1023.418,472.176a4.716,4.716,0,0,0,7.828-3.539,5.051,5.051,0,0,0-.25-1.539",
    transform: "translate(-1013.334 -460.978)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4220",
    "data-name": "Path 4220",
    d: "M1026.528,476.291s-7.27.346-13.194-7.655c5.924-8.02,13.194-7.655,13.194-7.655",
    transform: "translate(-1013.334 -460.978)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M1026.528,476.291s7.27.346,13.194-7.655c-5.924-8.02-13.194-7.655-13.194-7.655",
    transform: "translate(-1013.334 -460.978)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    d: "M1026.228,466.461a3.486,3.486,0,0,1,1.148.19,3.07,3.07,0,0,1,.973.542A2.512,2.512,0,0,1,1029,468a2.122,2.122,0,0,1,0,1.914,2.512,2.512,0,0,1-.651.811,3.069,3.069,0,0,1-.973.542,3.563,3.563,0,0,1-2.3,0,3.068,3.068,0,0,1-.973-.542,2.512,2.512,0,0,1-.651-.811,2.123,2.123,0,0,1,0-1.914,2.512,2.512,0,0,1,.651-.811,3.069,3.069,0,0,1,.973-.542,3.491,3.491,0,0,1,1.148-.19",
    transform: "translate(-1013.334 -460.978)",
    fill: "#ffc524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabReport);
export default __webpack_public_path__ + "static/media/labReport.63842f350d5183f6d837a109ae77c62b.svg";
export { ForwardRef as ReactComponent };